module.exports = __webpack_public_path__ + "static/media/mobileBG.7772e9aa.svg";